import { ExternalLink, Menu as MenuIcon } from "lucide-mui"
import React, { useState } from "react"
import { Link } from "react-router-dom"

import { BG_DARK } from "@/constants/colors"
import i18n from "@/i18n"
import PublicLanguageDropdown from "@/pages/public/language_dropdown"
import Logo from "@/pages/public/logo"
import PublicMobileMenuDrawer from "@/pages/public/mobile_menu_drawer"

const STYLES = {
  bar: "h-[50px] w-full flex items-center",
  inner: "mx-auto flex w-full max-w-[1100px] items-center justify-between px-5",
  logoLink: "inline-block",
  logo: "h-[19px] w-[75px]",
  actions: "hidden sm:flex items-center gap-[20px] text-white md:gap-[30px]",
  businessLink: "flex items-center gap-[6px] text-[14px] leading-none text-white no-underline",
  businessIcon: "h-[10px] w-[10px]",
  businessLabel: "hidden sm:inline",
  hamburgerBtn: "flex sm:hidden h-8 w-8 items-center justify-center text-white",
  hamburgerIcon: "h-6 w-6",
} as const

const PublicTopBar: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <header className={STYLES.bar} style={{ backgroundColor: BG_DARK }} data-testid="public-venue-top-bar">
      <div className={STYLES.inner}>
        <Link to="/" className={STYLES.logoLink} data-testid="public-venue-logo-link">
          <Logo variant="with-icon" className={STYLES.logo} />
        </Link>
        <div className={STYLES.actions}>
          <Link to="/" className={STYLES.businessLink} data-testid="public-venue-for-business-link">
            <ExternalLink className={STYLES.businessIcon} />
            <span className={STYLES.businessLabel}>{i18n.t("app.public.venue.footer.for_business")}</span>
          </Link>
          <PublicLanguageDropdown />
        </div>
        <button
          type="button"
          onClick={() => setMenuOpen(true)}
          className={STYLES.hamburgerBtn}
          aria-label={i18n.t("app.public.venue.top_bar.open_menu")}
          data-testid="public-venue-mobile-menu-btn"
        >
          <MenuIcon className={STYLES.hamburgerIcon} />
        </button>
      </div>
      <PublicMobileMenuDrawer open={menuOpen} onClose={() => setMenuOpen(false)} />
    </header>
  )
}

export default PublicTopBar
